'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Copy-module_container__i26nM{height:auto;vertical-align:middle;width:1rem;fill:#000}";
var styles = {"container":"Copy-module_container__i26nM"};
styleInject["default"](css_248z, '41dc08d7-2522-4938-a973-2643a73c71ec');

exports["default"] = styles;
